// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"cb0068ba","269":"df30ca88","730":"2d0e781c"}[chunkId] + ".chunk.css";
};